export default class LocalizedError extends Error {
  constructor(
    public override message: string,
    public translationKey: string,
  ) {
    super(message);
    this.translationKey = translationKey;
    Object.setPrototypeOf(this, LocalizedError.prototype);
  }
}
